import { render, staticRenderFns } from "./CS-average-prediction-widgets.vue?vue&type=template&id=ad0f29fe"
import script from "./CS-average-prediction-widgets.vue?vue&type=script&lang=js"
export * from "./CS-average-prediction-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports